import { render, staticRenderFns } from "./MomentsTemplate.vue?vue&type=template&id=9d4ade5e&"
import script from "./MomentsTemplate.vue?vue&type=script&lang=js&"
export * from "./MomentsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports